module.exports = __webpack_public_path__ + "img/success_img.ef032b31.png";